<template>
<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.33333 4.9999L5.10667 8.77323L12.6667 1.22656" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>
<script lang="ts" setup>

</script>
